import { render, staticRenderFns } from "./EducationProgramKenya.vue?vue&type=template&id=520edbf9&scoped=true&"
import script from "./EducationProgramKenya.vue?vue&type=script&lang=ts&"
export * from "./EducationProgramKenya.vue?vue&type=script&lang=ts&"
import style0 from "./EducationProgramKenya.vue?vue&type=style&index=0&id=520edbf9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520edbf9",
  null
  
)

/* custom blocks */
import block0 from "./EducationProgramKenya.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports